import { ExperienceLanguage } from 'enums/experience/experienceLanguage';
import { FunctionComponent } from 'react';
import ClockwatchIcon from 'components/Icons/vehicle/clockwatch.svg';
import ThunderIcon from 'components/Icons/thunder.svg';
import { ArrowsClockwise, MapPin, Translate } from '@phosphor-icons/react';
import VehicleDetailTitledSection from 'components/Vehicle/VehicleDetail/VehicleDetailTitledSection';
import useTranslation from 'next-translate/useTranslation';
import { getExperienceDurationByTime } from 'utils/experience/experienceDuration.util';

interface ExperienceDetailGeneralInfoProps {
  duration: number;
  cancellationPolicy: number;
  supportedLanguages: ExperienceLanguage[];
  harbor: string;
}

const ExperienceDetailGeneralInfo: FunctionComponent<
  ExperienceDetailGeneralInfoProps
> = ({ duration, cancellationPolicy, supportedLanguages, harbor }) => {
  const { t } = useTranslation('experience');

  const { hour, minute } = getExperienceDurationByTime(duration);

  return (
    <VehicleDetailTitledSection title={t('generalInfo.title')}>
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <ThunderIcon className="h-8 w-8 flex-shrink-0 fill-primary-500" />
          <div>{t('generalInfo.items.immediate')}</div>
        </div>
        <div className="flex items-center gap-2">
          <MapPin className="h-8 w-8 flex-shrink-0" />
          <div>
            {t('generalInfo.items.harbor')}: {harbor}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <ClockwatchIcon className="h-8 w-8 flex-shrink-0" />
          <div>
            {t('generalInfo.items.duration')}:{' '}
            {hour ? `${hour} ${t('common:experience.hour')} ` : ''}{' '}
            {minute ? `${minute} ${t('common:experience.minute')} ` : ''}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <ArrowsClockwise className="h-8 w-8 flex-shrink-0" />
          <div>
            {t('generalInfo.items.cancellationPolicy', {
              count: cancellationPolicy,
            })}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Translate className="h-8 w-8 flex-shrink-0" />
          <div>
            {t('generalInfo.items.supportedLanguages')}:{' '}
            {supportedLanguages
              .map((a) => t(`generalInfo.supportedLanguages.${a}`))
              .join(', ')}
          </div>
        </div>
      </div>
    </VehicleDetailTitledSection>
  );
};

export default ExperienceDetailGeneralInfo;
